import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { IDabType } from '@epicuro-next/state/dab-state';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faCartShopping,
  faCheck,
  faTruck,
} from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'atx-product-dab-item',
  templateUrl: './product-dab-item.component.html',
  styleUrls: ['./product-dab-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductDabItemComponent implements OnInit {
  private iconConfiguration: {
    [key: string]: IconDefinition;
  } = {
    inBasket: faCartShopping,
    inbound: faTruck,
    delivered: faCheck,
  };

  @HostBinding('class') public componentClass?: string = undefined;

  @Input()
  public quantity = NaN;

  @Input()
  public text = '';

  @Input()
  public type = IDabType.INBASKET;

  @Input()
  public extendedView = false;

  public get itemType(): IDabType {
    return this.type;
  }

  public get icon(): IconDefinition {
    return this.iconConfiguration[this.itemType];
  }

  public ngOnInit(): void {
    this.componentClass = this.itemType;
  }
}
